import OmdbAPI from "./omdb"

// exports OMDB API
export default () => new OmdbAPI()